var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{attrs:{"id":"designer-wrap"}},[_c('div',{staticClass:"background",class:_vm.app.filter,style:({backgroundImage: ("url(" + (_vm.app.background.backgroundImage) + ")")})},[_c(_vm.app.template || 'horizen_1',{tag:"component"})],1)])}
var staticRenderFns = []

export { render, staticRenderFns }